import React from "react";
import ChartReport from "./Report";

const ClientChart = ({ lastMonthData }) => {
  return (
    <>
      {/* Organization Details */}
      <ChartReport
        lastMonthData={lastMonthData}
        title="Clients"
        dataKey="organizationDetailCount"
      />
    </>
  );
};

export default ClientChart;
